const localisations = {
    general: {
        buttons: {
            back: "Back",
            next: "Next",
            finish: "Finish",
        },
    },
    createPreAlert: {
        stepper: {
            intro: "Overview",
            enterDetails: "Enter Details",
            enterCustomerSpecificDetails: "Enter Customer Specific Details",
            selectItems: "Select Items",
            confirmation: "Confirmation",
        },
        stages: {
            intro: {
                heading: "Overview",
                paragraphs: [
                    "Pre-Alerts are used to manage the expected receipt of inbound stock from suppliers.",
                    "The corresponding supplier order is created as part of this process.",
                ],
            },
            selectParent: {
                heading: "Select Parent",
                blurb: "",
            },
            enterDetails: {
                heading: "Enter Details",
                blurb: "",
                requiredDateLabel: "Required Date",
            },
            enterCustomerSpecificDetails: {
                heading: "Enter Customer Specific Details",
                blurb: "",
                wbsCodeLabel: "WBS Code",
                aucCodeLabel: "AUC Code",
                orderRaiserLabel: "Order Raiser",
                po1NumberLabel: "PO1 Number",
                po2NumberLabel: "PO2 Number",
            },
            selectItems: {
                heading: "Select Items",
                blurb: "",
                addButtonLabel: "Add Item",
                materialNumberLabel: "NSS Material Number",
                quantityLabel: "Quantity",
                unitValueLabel: "Unit Value",
            },
            confirmation: {
                heading: "Confirmation",
                blurb: "By clicking finish you confirm that the pre-alert details will be confirmed and sent to ByBox.",
                detailsHeading: "Details",
                customerSpecificHeading: "Customer Specific Details",
                itemsHeading: "Items",
                requiredDateLabel: "Required Date",
                partitionNameLabel: "Partition Name",
                supplierNameLabel: "Supplier Name",
                warehouseNameLabel: "Warehouse Name",
                wbsCodeLabel: "WBS Code",
                aucCodeLabel: "AUC Code",
                orderRaiserLabel: "Order Raiser",
                po1NumberLabel: "PO1 Number",
                po2NumberLabel: "PO2 Number",
                materialNumberLabel: "NSS Material Number",
                quantityLabel: "Quantity",
                unitValueLabel: "Unit Value",
                productLabel: "Product",
                currencyCodeLabel: "Currency Code",
            },
            result: {
                successMessage: "Success",
                errorMessage: "Error",
                validationErrorsMessage: "Some information is missing or incorrect:",
            },
        },
        serverErrors: {
            SupplierId: {
                Required: "Supplier is required.",
            },
            DestinationWarehouseId: {
                Required: "Warehouse is required.",
            },
            Quantity: {
                MinValue: "Quantity must be greater than zero (0).",
            },
            ProductId: {
                Required: "Product is required.",
            },
            UnitCost: {
                MinValue: "Unit cost must be zero (0) or greater.",
            },
        },
    },
    createPartition: {
        stepper: {
            intro: "Overview",
            selectParent: "Select Parent",
            enterDetails: "Enter Details",
            confirmation: "Confirmation",
        },
        stages: {
            intro: {
                heading: "Overview",
                paragraphs: [
                    "A Partition is a logical representation of stock. New Partitions are created as and when required by the business.",
                ],
            },
            selectParent: {
                heading: "Select Parent",
                blurb: "A Partition must exist in a node. Please select the partition's parent node.",
            },
            enterDetails: {
                heading: "Enter details",
                blurb: "",
            },
            confirmation: {
                heading: "Confirmation",
                blurb: "Please confirm the below details are correct before pressing the finish button.",
                pathLabel: "Parent Path",
                partitionParent: "Partition Parent",
                partitionName: "Partition Name",
                productName: "Product Name",
                productDescription: "Product Description",
                quantityChange: "Quantity Change",
                notes: "Notes",
                reference: "Reference",
                emailAddress: "Email Address",
                callOfCodes: "Call-Off Codes :",
            },
            result: {
                successMessage: "Success",
                errorMessage: "Error",
                validationErrorsMessage: "Some information is missing or incorrect:",
            },
        },
        serverErrors: {
            FieldCompanyId: {
                default: "Field company is required.",
            },
            parentHierarchyNodeId: {
                default: "Parent Partition is required.",
            },
            Name: {
                default: "Name is invalid.",
                Required: "A name is required.",
                MinLength: "Name is too short.",
                MaxLength: "Name is too long.",
            },
            Reference: {
                MaxLength: "Reference is too long.",
            },
            OwnerEmail: {
                InvalidEmail: "Project Manager Email must be a valid email address.",
                MaxLength: "Project Manager Email is too long.",
            },
            Notes: {
                MaxLength: "Notes section is too long.",
            },
        },
    },
    editPartition: {
        stepper: {
            intro: "Intro",
            enterDetails: "Edit Details",
            confirmation: "Confirmation",
        },
        stages: {
            intro: {
                heading: "Intro",
                paragraphs: ["Allows you to edit details relating to a Partition"],
            },
            enterDetails: {
                heading: "Edit details",
                blurb: "",
            },
            confirmation: {
                heading: "Confirmation",
                blurb: "Please confirm the below details are correct before pressing the finish button.",
                name: "Name",
                productName: "Product Name",
                quantityChange: "Quantity Change",
                notes: "Notes",
                reference: "Reference",
                ownerEmail: "Owner Email",
                callOfCodes: "Call-Off Codes :",
            },
            result: {
                successMessage: "Success",
                errorMessage: "Error",
                validationErrorsMessage: "Some information is missing or incorrect:",
            },
        },
        serverErrors: {
            Name: {
                default: "Name is invalid.",
                Required: "A name is required.",
                MinLength: "Name is too short.",
                MaxLength: "Name is too long.",
            },
            Reference: {
                MaxLength: "Reference is too long.",
            },
            OwnerEmail: {
                InvalidEmail: "PM Email must be a valid email address.",
                MaxLength: "PM Email is too long.",
            },
            Notes: {
                MaxLength: "Notes section is too long.",
            },
        },
    },
    adjustmentAllocation: {
        stepper: {
            intro: "Overview",
            selectPartition: "Select Partition",
            selectProductAndQuantity: "Select Product and Quantity",
            confirmation: "Confirmation",
        },
        stages: {
            intro: {
                heading: "Overview",
                paragraphs: [
                    "This workflow allows manual stock adjustment in the event that the stock ledger requires a correction.",
                    "Note: All adjustments are recorded in the transaction log and are fully audited.",
                ],
            },
            result: {
                heading: "Result",
                successMessage: "Success",
                errorMessage: "Error",
                validationErrorsMessage: "Some information is missing or incorrect:",
            },
            selectPartition: {
                heading: "Select Partition",
                blurb: "Select the Partition that you want to adjust",
            },
            selectProductAndQuantity: {
                heading: "Select Product and Quantity",
                blurb: "",
                quantityLabel: "Quantity",
                quantityHelperText: "",
                notesLabel: "Notes",
                notesHelperText: "",
            }
        },
        serverErrors: {
            FieldCompanyId: {
                default: "Field company is required.",
            },
            QuantityChange: {
                NotZero: "Quantity value can't be zero.",
                NegativeQuantity: "Adjustment would result in a negative quantity.",
            },
            PartitionId: {
                Required: "Partition is required.",
                InvalidPartition: "Partition is invalid.",
            },
            ProductId: {
                Required: "Product is required.",
                UnmanagedProduct: "Product is not managed by the Stock Ledger.",
            },
            Notes: {
                MaxLength: "Notes content is too long.",
                Required: "Notes are required for stock adjustment",
            },
            LastTransactionId: {
                InvalidLastTransaction: "The stock item has changed while you were viewing the data.",
            },
        },
    },
    movementAllocation: {
        stepper: {
            intro: "Overview",
            selectSourcePartition: "Select Origin Partition",
            selectProductAndQuantity: "Select Product and Quantity",
            selectTargetPartition: "Select Destination Partition",
            confirmation: "Confirmation",
        },
        stages: {
            intro: {
                heading: "Overview",
                paragraphs: ["This function facilitates inter-Partition stock transfers."],
            },
            result: {
                heading: "Result",
                successMessage: "Success",
                errorMessage: "Error",
                validationErrorsMessage: "Some information is missing or incorrect:",
            },
            selectSourcePartition: {
                heading: "Select Origin Partition",
                blurb: "Select the origin Partition for the stock movement.",
            },
            selectProductAndQuantity: {
                heading: "Select Product and Quantity",
                blurb: "",
                quantityLabel: "Quantity",
                quantityHelperText: "",
            },
            selectTargetPartition: {
                heading: "Select Destination Partition",
                blurb: "Select the destination Partition for the stock movement.",
            },
            confirmation: {
                heading: "Confirmation",
                blurb: "By pressing finish you will confirm this allocation.",
                sourcePartitionParent: "Source Partition Parent",
                sourcePartitionName: "Source Partition Name",
                productName: "Product Name",                
                productDescription: "Product Description",
                quantityChange: "Quantity Change",
                targetPartitionName: "Target Partition Name",
                targetPartitionParent: "Target Partition Parent",
            },
        },
        serverErrors: {
            FieldCompanyId: {
                default: "Field company is required.",
            },
            QuantityChange: {
                NotZero: "Quantity value can't be zero.",
                NegativeQuantity: "Movement would result in a negative quantity.",
                MinValue: "Quantity must be greater than zero (0).",
            },
            SourcePartitionId: {
                Required: "Source Partition is required.",
                InvalidPartition: "Partition is invalid.",
            },
            TargetPartitionId: {
                Required: "Target Partition is required.",
                InvalidPartition: "Partition is invalid.",
            },
            ProductId: {
                Required: "Product is required.",
                UnmanagedProduct: "Product is not managed by the Stock Ledger.",
            },
            Notes: {
                MaxLength: "Notes content is too long.",
            },
            LastTransactionId: {
                InvalidLastTransaction: "The stock item has changed while you were viewing the data.",
            },
        },
    },
    stockTransferImport: {
        stepper: {
            intro: "Overview",
            selectImportType: "Select Import Type",
            selectFile: "Select File",
            preCheckFile: "Pre-check File",
            confirmation: "Confirmation",
        },
        stages: {
            intro: {
                heading: "Overview",
                paragraphs: ["This workflow allows the processing of a number of different stock transfer files."],
            },
            result: {
                heading: "Result",
                successMessage: "Success",
                errorMessage: "Error",
                validationErrorsMessage: "Some information is missing or incorrect:",
            },
            selectImportType: {
                heading: "Select Import Type",
                selectText: "Import Type",
                "pega-file": {
                    importTypeName: "PEGA File",
                    description: "This import allows the processing of a PEGA file.",
                },
                "unique-to-generic-sku-migration": {
                    importTypeName: "Unique to Generic SKU Migration",
                    description:
                        "This import allows the migration of stock from a unique SKU to its generic counterpart.",
                },
                "project-to-surplus": {
                    importTypeName: "Project to Surplus Transfer",
                    description:
                        "This import allows the movement of stock between a project partition and a surplus partition.",
                },
            },
            selectFile: {
                heading: "Select File",
                blurb: "Select a file in the correct format for the selected import type.",
            },
            preCheckFile: {
                heading: "Pre-check File",
                blurb: "Before processing the file, the system first checks it for possible errors. If any errors are found, they will be displayed below. No stock transfers will be actioned at this step.",
                startPreCheckButton: "Start Pre-check",
            },
            confirmation: {
                heading: "Confirmation",
                blurb: "Once you are ready to process the stock transfers, press the button below.",
                startImportButton: "Start importing file",
            },
        },
        serverErrors: {
            // TODO: add server errors here once we know what they are!
        },
    },
    createCallOffCode: {
        clientErrors: {
            callOffCodeRequired: "Call-Off Code must have a value.",
            callOffCodeTooLong: "Please use less than 50 characters.",
        },
        callOffCodeNotAddedWarning: "Click + to add the call off code.",
    },
    consistencyCheck:{
        
    }
};

export default localisations;
